(function () {
    'use strict';

    angular
        .module('app')
        .controller('ExportEntityDialogCtrl', ExportEntityDialogCtrl);

    ExportEntityDialogCtrl.$inject = ['DialogInstance', 'EntitiesService', 'entityTemplate', 'entityCount', 'entityPreviewName', 'disableAllEntities'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog prompting the user for confirmation they wish to export entities
     * 
     */
    function ExportEntityDialogCtrl(DialogInstance, EntitiesService, entityTemplate, entityCount, entityPreviewName, disableAllEntities) {
        /* jshint validthis:true */
        var vm = this;
        vm.transpose = false;
        vm.showAdvanced = false;
        vm.includeLookups = false;
        vm.loading = true;
        vm.allFieldsSelected = true;
        vm.entityTemplate = entityTemplate;
        vm.entityCount = entityCount;
        vm.entityPreviewName = entityPreviewName;
        vm.disableAllEntities = disableAllEntities;
        vm.title = 'Export ' + vm.entityTemplate.PluralName;
        vm.ok = ok;
        vm.cancel = cancel;
        Object.defineProperty(vm, 'selectedFieldsCount', { get: getSelectedFieldsCount });

        activate();

        function activate() {
            if ((!_.isNil(entityPreviewName) && entityPreviewName !== '') ||
                (!_.isNil(entityCount) && entityCount > 0)) {
                vm.exportType = 'currentSelection';
            } else if (_.isNil(disableAllEntities) || !disableAllEntities) {
                vm.exportType = 'allEntities';
            } else {
                vm.exportType = 'blankTemplate';
            }

            EntitiesService.getPreExportReport(vm.entityTemplate.Id)
                .then(getPreExportReportOk, getPreExportReportError)
                .finally(function () {
                    vm.loading = false;
                });

            function getPreExportReportOk(response) {
                angular.forEach(response.Fields, function (field) {
                    field.Selected = true;
                });

                vm.preExportReport = response;
            }

            function getPreExportReportError(response) {
                vm.error = 'Error retrieving Pre-Export report.';
            }
        }

        /*
         * Get the count of fields which are currently selected
         */
        function getSelectedFieldsCount() {
            var count = 0;

            if (!_.isNil(vm.preExportReport)) {
                count = _.filter(vm.preExportReport.Fields, function (field) {
                    return field.Selected;
                }).length;
            }

            return count;
        }

        function ok() {
            var fieldsToExport = _.map(_.filter(vm.preExportReport.Fields, function (field) { return field.Selected; }), function (field) { return field.Path; });

            DialogInstance.ok({ ExportType: vm.exportType, IncludeLookups: vm.includeLookups, Transpose: vm.transpose, FieldsToExport: fieldsToExport });
        }

        function cancel() {
            DialogInstance.cancel();
        }
    }
})();
